import { render } from "./_index.vue?vue&type=template&id=5b24ea97&scoped=true"
import script from "./_index.vue?vue&type=script&lang=js"
export * from "./_index.vue?vue&type=script&lang=js"

import "./_index.vue?vue&type=style&index=0&id=5b24ea97&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b24ea97"]])

export default __exports__